// import firebase from "firebase";
import db from "./db.js";
import { OlabPrimer } from "./olabprimer.js";
import { OlabGene } from "./olabgene.js";
import { OlabDataFile } from "./olabdatafile.js";
import { OlabUtils } from "./olabutils.js";

class OlabBlock {
  constructor(olab_id) {
    // OlabUtils.infoLog("OlabBlock.constructor() ...");
    this.olab_id = olab_id;
    this.seq = null;
    this.block = -1;
    this.start = -1;
    this.range = -1;
    this.next_block = -1;
    this.prev_block = -1;
  }

  static getConfigBlock(id, configBlockArr) {
    const firstDashIndex = id.indexOf("-");
    const microbeID = id.substr(0, firstDashIndex);
    let strainID = id.substr(0, id.length - 9);
    let chromosomeID = id.substr(0, id.length - 5);

    // OlabUtils.infoLog("Before: microbeID = " + microbeID + ", strainID = " + strainID + ", chromosomeID = " + chromosomeID);
    switch (strainID) {
      case "CGL-CJ0001" /* block for cj's cgl is the same as olab's cgl */:
        strainID = "CGL-S00001";
        chromosomeID = "CGL-S00001-C01";
        break;
      case "ECO-CJ0001" /* block for cj's eco is the same as olab's eco */:
        strainID = "ECO-S00001";
        chromosomeID = "ECO-S00001-C01";
        break;
    }
    // OlabUtils.infoLog("After: microbeID = " + microbeID + ", strainID = " + strainID + ", chromosomeID = " + chromosomeID);

    for (let i = 0; i < configBlockArr.length; i++) {
      if (chromosomeID == configBlockArr[i].olab_id) {
        configBlockArr[i].microbeID = microbeID;
        configBlockArr[i].strainID = strainID;
        return configBlockArr[i];
      }
    }
    return null;
  }

  static fillGeneSeqAndUpload(microbeID, strainID, gene, blockConfig) {
    return new Promise(resolve => {
      setTimeout(resolve, 1);

      const seqFrom = Number(gene.sequence.from);
      const seqTo = Number(gene.sequence.to);
      const seqLen = seqTo - seqFrom + 1;
      // comp is the complement info
      const comp = gene.sequence.comp == "true";
      OlabUtils.infoLog(
        "seqFrom = " +
          seqFrom +
          ", seqTo = " +
          seqTo +
          ", seqLen = " +
          seqLen +
          ", comp = " +
          comp
      );
      const TOTAL_SEQ_SIZE = blockConfig.total_seq_size;
      const LAST_BLOCK_SIZE = blockConfig.last_block_size;
      const BLOCK_SIZE = blockConfig.block_size;
      const MAX_BLOCKS = blockConfig.max_blocks;

      let blockID = 0;
      let indexInBlock = 0;

      let seqOffset = seqFrom - 1;
      OlabUtils.infoLog("** seqOffset = " + seqOffset);

      // Handle complement case here.
      OlabUtils.infoLog("** comp = " + comp);
      if (comp) {
        // Reverse complement case
        seqOffset = seqTo - seqLen;
        OlabUtils.infoLog("** comp case: seqOffset = " + seqOffset);
        OlabUtils.infoLog(
          "** comp case: seqTo = " + seqTo + ", seqFrom = " + seqFrom
        );
      }

      // Handle positive seqOffset case
      if (seqOffset >= 0) {
        // Wrap seqOffset if it great than TOTAL_SEQ_SIZE
        if (seqOffset >= TOTAL_SEQ_SIZE) {
          OlabUtils.infoLog("** seqOffset >= TOTAL_SEQ_SIZE: " + seqOffset);
          seqOffset = seqOffset % TOTAL_SEQ_SIZE;
          OlabUtils.infoLog("** Wrapped seqOffset = " + seqOffset);
        }

        blockID = Math.floor(seqOffset / BLOCK_SIZE);
        indexInBlock = seqOffset % BLOCK_SIZE;
      } else {
        // Wrap -seqOffset if it lesser than -TOTAL_SEQ_SIZE
        if (seqOffset <= -TOTAL_SEQ_SIZE) {
          OlabUtils.infoLog("** seqOffset <= TOTAL_SEQ_SIZE: " + seqOffset);
          seqOffset = seqOffset % TOTAL_SEQ_SIZE;
          OlabUtils.infoLog("** Wrapped seqOffset = " + seqOffset);
        }
        const temp = TOTAL_SEQ_SIZE + seqOffset;
        blockID = Math.floor(temp / BLOCK_SIZE);
        indexInBlock = temp % BLOCK_SIZE;
      }
      // Need to handle if it is a last block case (may never need to b/c we have handle wrap condition)
      if (blockID == MAX_BLOCKS - 1 && indexInBlock >= LAST_BLOCK_SIZE) {
        OlabUtils.warnLog(
          "Trouble !!! blockID == (MAX_BLOCKS - 1) && indexInBlock >= LAST_BLOCK_SIZE"
        );
      }
      OlabUtils.infoLog("** blockID = " + blockID);
      OlabUtils.infoLog(
        "indexInBlock = " + indexInBlock + ", BLOCK_SIZE = " + BLOCK_SIZE
      );

      let numOfBlocks = Math.floor((indexInBlock + seqLen) / BLOCK_SIZE) + 1;
      // Pack in an extra block incase of wrapping
      if (blockID + numOfBlocks >= MAX_BLOCKS) {
        numOfBlocks++;
        OlabUtils.infoLog("Add one more block for wrapping: " + numOfBlocks);
      }
      if (numOfBlocks > MAX_BLOCKS) {
        OlabUtils.warnLog(
          "numOfBlocks >= MAX_BLOCKS: " +
            numOfBlocks +
            ". CLAMP numOfBlocks to MAX_BLOCKS"
        );
        numOfBlocks = MAX_BLOCKS;
      }
      OlabUtils.infoLog("** numOfBlocks needed = " + numOfBlocks);
      const blockOrderArr = [];
      blockOrderArr.push(blockID);
      if (numOfBlocks > 1) {
        OlabUtils.infoLog("... more numOfBlocks case = " + numOfBlocks);
        if (blockID == MAX_BLOCKS - 1) {
          let index = 0;
          for (let i = 1; i < numOfBlocks; i++) {
            blockOrderArr.push(index);
            index++;
          }
        } else {
          let index = blockID + 1;
          for (let i = 1; i < numOfBlocks; i++) {
            if (index >= MAX_BLOCKS) {
              index = 0;
            }
            blockOrderArr.push(index);
            index++;
          }
        }
      }

      // Construct db path
      const collectionStr =
        "microbes/" +
        blockConfig.microbeID +
        "/olab_items/" +
        blockConfig.strainID +
        "/olab_blocks";

      OlabUtils.infoLog("collectionStr = " + collectionStr);

      db.collection(collectionStr)
        .where("block", "in", blockOrderArr)
        .limit(numOfBlocks)
        .get()
        .then(snapshot => {
          const snapArr = [];
          snapshot.forEach(doc => {
            // OlabUtils.infoLog("** " + doc.id + " => " + doc.data());
            snapArr.push(doc.data());
          });
          OlabUtils.infoLog("snapArr len = " + snapArr.length);
          if (snapArr.length > 0) {
            if (numOfBlocks == 1) {
              let seqFrag = snapArr[0].seq.substr(indexInBlock, seqLen);
              if (comp) {
                seqFrag = OlabPrimer.complementSeq(seqFrag);
                // OlabUtils.infoLog("Complemented seqFrag = " + seqFrag);
                seqFrag = OlabPrimer.reverseSeq(seqFrag);
                // OlabUtils.infoLog("reversed = " + seqFrag);
              }

              gene.sequence.seq = seqFrag;
              gene.gene_stats = OlabDataFile.computeSeqStat(gene.sequence.seq);
              OlabUtils.infoLog("Case 1: seqFrag = " + seqFrag);
            } else if (numOfBlocks > 1) {
              if (blockOrderArr.length == snapArr.length) {
                let bigSeq = "";
                let matchCount = 0;
                for (let i = 0; i < blockOrderArr.length; i++) {
                  for (let j = 0; j < snapArr.length; j++) {
                    if (snapArr[j].block == blockOrderArr[i]) {
                      bigSeq += snapArr[j].seq;
                      matchCount++;
                      break;
                    }
                  }
                }
                OlabUtils.infoLog(
                  "matchCount = " +
                    matchCount +
                    ", numOfBlocks = " +
                    numOfBlocks
                );
                // OlabUtils.infoLog("bigSeq = " + bigSeq);
                let seqFrag = bigSeq.substr(indexInBlock, seqLen);
                // Fill the remainding from the beginning
                if (seqFrag.length < seqLen) {
                  seqFrag = seqFrag + bigSeq.substr(0, seqLen - seqFrag.length);
                }
                if (comp) {
                  seqFrag = OlabPrimer.complementSeq(seqFrag);
                  // OlabUtils.infoLog("Complemented seqFrag = " + seqFrag);
                  seqFrag = OlabPrimer.reverseSeq(seqFrag);
                  // OlabUtils.infoLog("reversed = " + seqFrag);
                }
                gene.sequence.seq = seqFrag;
                gene.gene_stats = OlabDataFile.computeSeqStat(
                  gene.sequence.seq
                );
                OlabUtils.infoLog("Case 2: seqFrag = " + seqFrag);
              } else {
                OlabUtils.warnLog(
                  "Trouble!!! blockOrderArr.length != snapArr.length"
                );
              }
            } else {
              OlabUtils.warnLog(
                "Trouble!!! negative numOfBlocks = " + numOfBlocks
              );
            }

            OlabUtils.infoLog("XXX  gene.olab_id = " + gene.olab_id);
            const collectionStr =
              "microbes/" +
              microbeID +
              "/olab_items/" +
              strainID +
              "/olab_genes";
            db.collection(collectionStr)
              .withConverter(OlabGene.getOlabGeneConverter())
              .doc(gene.olab_id)
              .set(gene, { merge: true })
              .then(function() {
                OlabUtils.infoLog(
                  "Document successfully written! gene.olab_id = " +
                    gene.olab_id
                );
              })
              .catch(function(error) {
                OlabUtils.infoLog("Error writing document: " + error);
              });
          }
        });
    });
  }

  static computeSequence(seq, start, range, blockConfig, ccp, cmp) {
    const seqFrom = Number(seq.sequence.from);
    const seqTo = Number(seq.sequence.to);
    const seqLen = seqTo - seqFrom + 1;
    // comp is the complement info
    const comp = seq.sequence.comp == "true";
    OlabUtils.infoLog(
      "computeSequence: seqFrom = " +
        seqFrom +
        ", seqTo = " +
        seqTo +
        ", seqLen = " +
        seqLen +
        ", comp = " +
        comp
    );

    OlabUtils.infoLog(
      "computeSequence: start = " + start + ", range = " + range
    );

    const TOTAL_SEQ_SIZE = blockConfig.total_seq_size;
    const LAST_BLOCK_SIZE = blockConfig.last_block_size;
    const BLOCK_SIZE = blockConfig.block_size;
    const MAX_BLOCKS = blockConfig.max_blocks;

    let blockID = 0;
    let indexInBlock = 0;

    let seqOffset = seqFrom - 1 + start;
    // OlabUtils.infoLog("** seqOffset = " + seqOffset);

    // Handle complement case here.
    // OlabUtils.infoLog("** comp = " + comp);
    if (comp) {
      // Reverse complement case
      seqOffset = seqTo - start;
      seqOffset -= range;
      // OlabUtils.infoLog("** comp case: seqOffset = " + seqOffset);
      // OlabUtils.infoLog("** comp case: seqTo = " + seqTo + ", seqFrom = " + seqFrom);
    }

    // Handle positive seqOffset case
    if (seqOffset >= 0) {
      // Wrap seqOffset if it great than TOTAL_SEQ_SIZE
      if (seqOffset >= TOTAL_SEQ_SIZE) {
        // OlabUtils.infoLog("** seqOffset >= TOTAL_SEQ_SIZE: " + seqOffset);
        seqOffset = seqOffset % TOTAL_SEQ_SIZE;
        // OlabUtils.infoLog("** Wrapped seqOffset = " + seqOffset);
      }

      blockID = Math.floor(seqOffset / BLOCK_SIZE);
      indexInBlock = seqOffset % BLOCK_SIZE;
    } else {
      // Wrap -seqOffset if it lesser than -TOTAL_SEQ_SIZE
      if (seqOffset <= -TOTAL_SEQ_SIZE) {
        // OlabUtils.infoLog("** seqOffset <= TOTAL_SEQ_SIZE: " + seqOffset);
        seqOffset = seqOffset % TOTAL_SEQ_SIZE;
        // OlabUtils.infoLog("** Wrapped seqOffset = " + seqOffset);
      }
      const temp = TOTAL_SEQ_SIZE + seqOffset;
      blockID = Math.floor(temp / BLOCK_SIZE);
      indexInBlock = temp % BLOCK_SIZE;
    }
    // Need to handle if it is a last block case (may never need to b/c we have handle wrap condition)
    if (blockID == MAX_BLOCKS - 1 && indexInBlock >= LAST_BLOCK_SIZE) {
      OlabUtils.warnLog(
        "Trouble !!! blockID == (MAX_BLOCKS - 1) && indexInBlock >= LAST_BLOCK_SIZE"
      );
    }
    // OlabUtils.infoLog("** blockID = " + blockID);
    // OlabUtils.infoLog("indexInBlock = " + indexInBlock + ", BLOCK_SIZE = " + BLOCK_SIZE);

    let numOfBlocks = Math.floor((indexInBlock + range) / BLOCK_SIZE) + 1;
    // Pack in an extra block incase of wrapping
    if (blockID + numOfBlocks >= MAX_BLOCKS) {
      numOfBlocks++;
      // OlabUtils.infoLog("Add one more block for wrapping: " + numOfBlocks);
    }
    if (numOfBlocks > MAX_BLOCKS) {
      OlabUtils.warnLog(
        "numOfBlocks >= MAX_BLOCKS: " +
          numOfBlocks +
          ". CLAMP numOfBlocks to MAX_BLOCKS"
      );
      numOfBlocks = MAX_BLOCKS;
    }
    // OlabUtils.infoLog("** numOfBlocks needed = " + numOfBlocks);
    const blockOrderArr = [];
    blockOrderArr.push(blockID);
    if (numOfBlocks > 1) {
      // OlabUtils.infoLog("... more numOfBlocks case = " + numOfBlocks);
      if (blockID == MAX_BLOCKS - 1) {
        let index = 0;
        for (let i = 1; i < numOfBlocks; i++) {
          blockOrderArr.push(index);
          index++;
        }
      } else {
        let index = blockID + 1;
        for (let i = 1; i < numOfBlocks; i++) {
          if (index >= MAX_BLOCKS) {
            index = 0;
          }
          blockOrderArr.push(index);
          index++;
        }
      }
    }

    // Construct db path
    const collectionStr =
      "microbes/" +
      blockConfig.microbeID +
      "/olab_items/" +
      blockConfig.strainID +
      "/olab_blocks";

    // OlabUtils.infoLog("collectionStr = " + collectionStr);

    db.collection(collectionStr)
      .where("block", "in", blockOrderArr)
      .limit(numOfBlocks)
      .get()
      .then(snapshot => {
        const snapArr = [];
        snapshot.forEach(doc => {
          // OlabUtils.infoLog("** " + doc.id + " => " + doc.data());
          snapArr.push(doc.data());
        });
        // OlabUtils.infoLog("snapArr len = " + snapArr.length);
        if (snapArr.length > 0) {
          if (numOfBlocks == 1) {
            let seqFrag = snapArr[0].seq.substr(indexInBlock, range);
            if (comp) {
              seqFrag = OlabPrimer.complementSeq(seqFrag);
              // OlabUtils.infoLog("Complemented seqFrag = " + seqFrag);
              seqFrag = OlabPrimer.reverseSeq(seqFrag);
              // OlabUtils.infoLog("reversed = " + seqFrag);
            }

            if (ccp) {
              ccp.setSeq(seqFrag);
            } else {
              cmp.seq = seqFrag;
            }
          } else if (numOfBlocks > 1) {
            if (blockOrderArr.length == snapArr.length) {
              let bigSeq = "";
              let matchCount = 0;
              for (let i = 0; i < blockOrderArr.length; i++) {
                for (let j = 0; j < snapArr.length; j++) {
                  if (snapArr[j].block == blockOrderArr[i]) {
                    bigSeq += snapArr[j].seq;
                    matchCount++;
                    break;
                  }
                }
              }
              OlabUtils.infoLog(
                "matchCount = " + matchCount + ", numOfBlocks = " + numOfBlocks
              );
              // OlabUtils.infoLog("bigSeq = " + bigSeq);
              let seqFrag = bigSeq.substr(indexInBlock, range);
              // Fill the remainding from the beginning
              if (seqFrag.length < range) {
                seqFrag = seqFrag + bigSeq.substr(0, range - seqFrag.length);
              }
              if (comp) {
                seqFrag = OlabPrimer.complementSeq(seqFrag);
                // OlabUtils.infoLog("Complemented seqFrag = " + seqFrag);
                seqFrag = OlabPrimer.reverseSeq(seqFrag);
                // OlabUtils.infoLog("reversed = " + seqFrag);
              }

              if (ccp) {
                ccp.setSeq(seqFrag);
              } else {
                cmp.seq = seqFrag;
              }
            } else {
              OlabUtils.warnLog(
                "Trouble!!! blockOrderArr.length != snapArr.length"
              );
            }
          } else {
            OlabUtils.warnLog(
              "Trouble!!! negative numOfBlocks = " + numOfBlocks
            );
          }
        }
      });
  }

  static infoLog(blk) {
    OlabUtils.infoLog(" - blk.olab_id = " + blk.olab_id);
    OlabUtils.infoLog(" - blk.seq = " + blk.seq);
    OlabUtils.infoLog(" - blk.block = " + blk.block);
    OlabUtils.infoLog(" - blk.start = " + blk.start);
    OlabUtils.infoLog(" - blk.range = " + blk.range);
    OlabUtils.infoLog(" - blk.next_block = " + blk.next_block);
    OlabUtils.infoLog(" - blk.prev_block = " + blk.prev_block);
  }
}

export { OlabBlock };
